import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.showDialog();
    }
  };

  open() {
    this.showDialog();

    /**
     * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
     */
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}

(function() {

  function initUpsellLogic() {
    var box = document.getElementById('cart-upsell-box');

    // Hide upsell if user already added it this session
    if (sessionStorage.getItem('upsell_hidden') === 'true') {
      if (box) box.style.display = 'none';
      return;
    }

    var btn = document.querySelector('.add-eyemask-upsell');
    if (!btn) return;

    btn.addEventListener('click', function() {
      if (btn.dataset.loading === 'true') return;

      var id = Number(btn.dataset.variant);
      btn.dataset.loading = 'true';
      btn.disabled = true;
      btn.innerText = 'Toegevoegd...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: id, quantity: 1 })
      })
      .then(function() {
        sessionStorage.setItem('upsell_hidden', 'true');
        if (box) box.style.display = 'none';

        var sectionId = document.querySelector('cart-items-component')?.dataset.sectionId;
        if (!sectionId) return;

        return fetch(window.location.pathname + '?section_id=' + encodeURIComponent(sectionId));
      })
      .then(function(res) { return res?.text(); })
      .then(function(html) {
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newItems = doc.querySelector('cart-items-component');
        var currentItems = document.querySelector('cart-items-component');
        if (newItems && currentItems) currentItems.innerHTML = newItems.innerHTML;
      })
      .catch(function() {
        btn.disabled = false;
        btn.innerText = 'Toevoegen';
        btn.dataset.loading = 'false';
      });
    });
  }

  // Observe cart drawer changes and re initialize upsell logic
  var observer = new MutationObserver(function() {
    initUpsellLogic();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  // First run
  document.addEventListener('DOMContentLoaded', initUpsellLogic);

})();

